// Cyber Air Hockey 60Hz Server Engine (2 Players + Spectators)
export class AirHockeyEngine {
  constructor(io, room) {
    this.io = io;
    this.room = room;
    this.tableW = 800;
    this.tableH = 440;
    this.puck = { x: 400, y: 220, vx: 0, vy: 0, r: 16 };
    this.mallets = {};
    this.scores = { p1: 0, p2: 0 };
    this.players = [];
    this.loopInterval = null;
  }

  start() {
    const shouldFillBots = this.room.settings?.fillBots !== false;
    this.players = this.room.players.slice(0, 2).map(p => ({ id: p.id, name: p.name, isBot: !!p.isBot }));

    if (this.players.length === 1 && shouldFillBots) {
      this.players.push({ id: 'bot_hockey', name: 'Cyber Puck Bot 🏒', isBot: true });
    }

    this.mallets = {
      [this.players[0].id]: { id: this.players[0].id, team: 'p1', x: 120, y: 220, r: 24, color: '#ef4444', isBot: this.players[0].isBot }
    };

    if (this.players[1]) {
      this.mallets[this.players[1].id] = { id: this.players[1].id, team: 'p2', x: 680, y: 220, r: 24, color: '#38bdf8', isBot: this.players[1].isBot };
    }

    this.scores = { p1: 0, p2: 0 };
    this.resetPuck();

    this.io.to(this.room.code).emit('hockey_started', {
      players: this.players,
      mallets: this.mallets,
      scores: this.scores
    });

    if (this.loopInterval) clearInterval(this.loopInterval);
    this.loopInterval = setInterval(() => this.update(), 1000 / 60);
  }

  resetPuck() {
    this.puck.x = 400;
    this.puck.y = 220;
    this.puck.vx = (Math.random() > 0.5 ? 1 : -1) * 6;
    this.puck.vy = (Math.random() - 0.5) * 6;
  }

  handlePaddle(playerId, x, y) {
    const m = this.mallets[playerId];
    if (m) {
      if (m.team === 'p1') {
        m.x = Math.max(30, Math.min(380, x));
      } else {
        m.x = Math.max(420, Math.min(this.tableW - 30, x));
      }
      m.y = Math.max(30, Math.min(this.tableH - 30, y));
    }
  }

  update() {
    // Bot Mallet AI
    for (const id in this.mallets) {
      const m = this.mallets[id];
      if (m.isBot) {
        const targetX = Math.max(480, Math.min(740, this.puck.x > 400 ? this.puck.x + 30 : 660));
        const targetY = Math.max(50, Math.min(390, this.puck.y));
        m.x += (targetX - m.x) * 0.15;
        m.y += (targetY - m.y) * 0.15;
      }
    }

    // Puck movement & friction
    this.puck.x += this.puck.vx;
    this.puck.y += this.puck.vy;
    this.puck.vx *= 0.992;
    this.puck.vy *= 0.992;

    // Cushion Bounces (Top & Bottom)
    if (this.puck.y <= 24 + this.puck.r) { this.puck.y = 24 + this.puck.r; this.puck.vy = -this.puck.vy; }
    if (this.puck.y >= this.tableH - 24 - this.puck.r) { this.puck.y = this.tableH - 24 - this.puck.r; this.puck.vy = -this.puck.vy; }

    // Goal Check or Left/Right Cushion Bounce
    const isGoalY = this.puck.y >= 140 && this.puck.y <= 300;
    if (this.puck.x <= 24 + this.puck.r) {
      if (isGoalY) {
        this.scores.p2++;
        this.io.to(this.room.code).emit('hockey_goal', { scorer: 'p2', scores: this.scores });
        this.resetPuck();
      } else {
        this.puck.x = 24 + this.puck.r;
        this.puck.vx = -this.puck.vx;
      }
    }
    if (this.puck.x >= this.tableW - 24 - this.puck.r) {
      if (isGoalY) {
        this.scores.p1++;
        this.io.to(this.room.code).emit('hockey_goal', { scorer: 'p1', scores: this.scores });
        this.resetPuck();
      } else {
        this.puck.x = this.tableW - 24 - this.puck.r;
        this.puck.vx = -this.puck.vx;
      }
    }

    // Mallet to Puck Collision
    for (const id in this.mallets) {
      const m = this.mallets[id];
      const dx = this.puck.x - m.x;
      const dy = this.puck.y - m.y;
      const dist = Math.hypot(dx, dy);

      if (dist < m.r + this.puck.r) {
        const nx = dx / dist;
        const ny = dy / dist;
        const speed = 14;
        this.puck.vx = nx * speed;
        this.puck.vy = ny * speed;
      }
    }

    this.io.to(this.room.code).emit('hockey_state', {
      puck: this.puck,
      mallets: this.mallets,
      scores: this.scores
    });

    // Win at 7 points
    if (this.scores.p1 >= 7 || this.scores.p2 >= 7) {
      clearInterval(this.loopInterval);
      const winner = this.scores.p1 >= 7 ? this.players[0] : this.players[1];
      this.io.to(this.room.code).emit('hockey_gameOver', { winner, scores: this.scores });
    }
  }

  destroy() {
    if (this.loopInterval) clearInterval(this.loopInterval);
  }
}
